import { useState } from "react";
import { mastheadMeta } from "@/mocks/homeData";

const navItems = [
  { label: "今日速递", href: "#today" },
  { label: "大图特辑", href: "#features" },
  { label: "档案合集", href: "#archive" },
  { label: "实时爆料", href: "#live" },
  { label: "订阅速递", href: "#subscribe" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/70 bg-background-50/90 backdrop-blur">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-6 md:h-[72px]">
          <a href="#top" className="flex items-center gap-3 group">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-bold text-background-50">
              44
            </span>
            <span className="leading-none">
              <h1 className="font-heading text-lg font-black tracking-tight text-foreground-950 md:text-xl">
                {mastheadMeta.brand}
              </h1>
              <span className="mt-0.5 block font-label text-[10px] tracking-[0.22em] text-secondary-600">
                {mastheadMeta.volume} · 深夜速递
              </span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 md:flex">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="whitespace-nowrap rounded-md px-3 py-2 font-label text-sm text-foreground-700 transition-colors duration-200 hover:bg-background-100 hover:text-primary-700"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <span className="hidden whitespace-nowrap font-label text-xs text-secondary-600 lg:block">
              {mastheadMeta.date} · {mastheadMeta.weekday}
            </span>
            <a
              href="#subscribe"
              className="hidden whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 font-label text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600 md:block"
            >
              订阅
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
            >
              <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 md:hidden">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="border-b border-background-200/60 py-3 font-label text-sm text-foreground-800 last:border-b-0"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}